import { ScreenerFilters, ScreenerResponse } from '../types/screener';

const EODHD_API_KEY = process.env.REACT_APP_EODHD_API_TOKEN;
const EODHD_BASE_URL = 'https://eodhd.com/api/screener';

export const getScreenerResults = async (filters: ScreenerFilters): Promise<ScreenerResponse> => {
  const queryParams = new URLSearchParams();
  
  // Add API key
  queryParams.append('api_token', EODHD_API_KEY || '');
  
  // Add filters
  if (filters.filters && filters.filters.length > 0) {
    const filterArray = filters.filters.map(filter => 
      [filter.field, filter.operation, filter.value]
    );
    queryParams.append('filters', JSON.stringify(filterArray));
  }

  // Add sort
  if (filters.sort) {
    queryParams.append('sort', filters.sort);
  }

  // Add signals
  if (filters.signals && filters.signals.length > 0) {
    queryParams.append('signals', filters.signals.join(','));
  }

  // Add pagination
  if (filters.limit) queryParams.append('limit', filters.limit.toString());
  if (filters.offset) queryParams.append('offset', filters.offset.toString());

  try {
    const response = await fetch(`${EODHD_BASE_URL}?${queryParams.toString()}`);
    if (!response.ok) {
      throw new Error('Failed to fetch screener results');
    }
    const data = await response.json();
    return {
      data: (data.data || []).map((item: any) => ({
        code: item.code || '',
        name: item.name || '',
        exchange: item.exchange || '',
        sector: item.sector || '',
        industry: item.industry || '',
        market_capitalization: typeof item.market_capitalization === 'number' ? item.market_capitalization : undefined,
        dividend_yield: typeof item.dividend_yield === 'number' ? item.dividend_yield : undefined,
        currency_symbol: item.currency_symbol || '$',
        last_day_data_date: item.last_day_data_date,
        adjusted_close: item.adjusted_close,
        refund_1d: item.refund_1d,
        refund_1d_p: item.refund_1d_p,
        refund_5d: item.refund_5d,
        refund_5d_p: item.refund_5d_p,
        earnings_share: item.earnings_share,
        avgvol_1d: item.avgvol_1d,
        avgvol_200d: item.avgvol_200d
      })),
      total: data.total
    };
  } catch (error) {
    console.error('Error fetching screener results:', error);
    throw error;
  }
};
